// Sincronizacion del progreso de la guia con la cuenta de la persona conectada (funciones puras, sin red ni DOM, para poder probarlas).
// Se sincronizan las claves «guiaAws.*» (vistos, favoritos, lecciones, checklist, notas, costos, nombre...) menos las preferencias de pantalla.
export const EXCLUIDAS = ["guiaAws.simple", "guiaAws.grande", "guiaAws.intro", "guiaAws.recorrido", "guiaAws.dueno", "guiaAws.sync_ts", "guiaAws.sucio"];
export const esSincronizable = (clave) => typeof clave === "string" && clave.startsWith("guiaAws.") && !EXCLUIDAS.includes(clave);

// Identificador de la persona dentro del token de sesion (no se valida aqui: el servidor lo valida en cada llamada)
export const idDeToken = (token) => {
    try {
        const p = String(token).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const j = JSON.parse(decodeURIComponent(escape(atob(p))));
        return j._id ? String(j._id) : "";
    } catch (e) { return ""; }
};

const analizar = (t) => { try { return JSON.parse(t); } catch (e) { return undefined; } };

// Primera vez que una persona conecta en este navegador: se unen sus datos locales (de cuando la guia era anonima) con los del servidor.
// Listas: union. Objetos: se mezclan clave a clave (listas dentro del objeto se unen). Textos: gana el del servidor y, si no hay, el local.
export const unir = (local, remoto) => {
    const salida = { ...remoto };
    Object.keys(local).forEach(k => {
        if (!(k in remoto)) { salida[k] = local[k]; return; }
        const a = analizar(local[k]), b = analizar(remoto[k]);
        if (Array.isArray(a) && Array.isArray(b)) salida[k] = JSON.stringify([...new Set([...b, ...a])]);
        else if (a && b && typeof a === "object" && typeof b === "object" && !Array.isArray(a) && !Array.isArray(b)) {
            const m = { ...a };
            Object.keys(b).forEach(x => { m[x] = Array.isArray(m[x]) && Array.isArray(b[x]) ? [...new Set([...b[x], ...m[x]])] : b[x]; });
            salida[k] = JSON.stringify(m);
        }
    });
    return salida;
};

// Que hacer al abrir la guia:
//   dueno   persona a la que pertenecen los datos locales («» si eran anonimos)       id      persona conectada
//   remoto  { datos, actualizado } del servidor (datos null si nunca guardo nada)       sucio   hay cambios locales sin subir
//   tsLocal marca de tiempo del servidor de la ultima sincronizacion de este navegador
// Devuelve { local: datos que quedan en el navegador, subir: datos a mandar al servidor o null }
export const decidir = ({ dueno, id, local, remoto, sucio, tsLocal }) => {
    const propios = dueno && dueno !== id ? {} : local;              // datos de otra persona en este navegador: se descartan
    if (!remoto || !remoto.datos) return { local: propios, subir: Object.keys(propios).length ? propios : null };
    if (dueno === id) {
        if (sucio) return { local: propios, subir: propios };         // trabajo pendiente de este navegador: se conserva y se sube
        if (Number(remoto.actualizado) > Number(tsLocal || 0)) return { local: remoto.datos, subir: null };
        return { local: propios, subir: null };
    }
    const u = unir(propios, remoto.datos);
    return { local: u, subir: u };
};
